import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";

import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import FormLabel from "@mui/material/FormLabel";
import makeStyles from "@mui/styles/makeStyles";
import createStyles from "@mui/styles/createStyles";
import FormGroup from "@mui/material/FormGroup";
import Switch from "@mui/material/Switch";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import { showToast } from "../../../store/actions";
import { ButtonUI } from "../../Common/Common";
import DeliveryFormatService from "../../../service/deliveryformat";

const useStyles = makeStyles((theme) =>
  createStyles({
    formLabel: {
      display: "flex",
      flexDirection: "row",
      "& .MuiFormLabel-root": {
        display: "inline-flex",
        width: "100%",
      },
      "& .MuiFormLabel-root.Status": {
        display: "inline-flex",
        width: "auto",
        alignItems: "center",
        color: "#000000de",
      },
      "& .MuiFormControlLabel-root": {
        display: "inline-flex",
        width: "fit-content",
        height: "30px",
      },
    },
    dialogPaper: {
      "& .MuiPaper-root": {
        maxWidth: "500px",
      },
      "& .MuiFormHelperText-root": {
        margin: 0,
        padding: 0,
      },
      "& .MuiGrid-item": {
        paddingTop: "15px",
      },
      "& .MuiGrid-item .MuiTextField-root": {
        marginTop: 0,
      },
      "& .MuiDivider-root": {
        marginTop: "5px",
        marginBottom: "9px",
      },
      "& .MuiDialogActions-root": {
        padding: "15px 20px 20px 0",
      },
    },
    formContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      padding: "0px 15px",
      textAlign: "left",
      minHeight: "200px",
    },
    container: {
      padding: "5px 5px 0 5px",
      backgroundColor: "#FFFFFF",
    },
    HalfTextField: {
      width: "calc(50% - 8px)",
    },
    Toolbar: {
      fontSize: "1.1rem",
      backgroundColor: "white",
      color: "black",
    },
    [theme.breakpoints.down("600")]: {
      HalfTextField: {
        width: "calc(100%)",
      },
    },
  })
);

const deliveryFormatTypes = ["text", "date"];

export default function AddForm({ setOpen, deliveryFormat, loaddata, categories }) {
  const [text, setText] = useState("");
  const [category, setCategory] = useState("");
  const [type, setType] = useState("");

  const [errors, setErrors] = useState({
    text: false,
    category: false,
  });

  const [active, setActive] = useState(1);
  const [loading, setLoading] = useState(false);

  const classes = useStyles();
  const dispatch = useDispatch();

  const handleSave = async () => {
    setErrors((prevState) => {
      return {
        ...prevState,
        text: text.trim().length < 2 || text.trim().length > 50,
      };
    });

    if (!(text.trim().length < 2 || text.trim().length > 50)) {
      setLoading(true);

      const data = {
        text,
        type,
        status: active,
        category_id: category,
      };

      let result = null;

      const deliveryFormatService = new DeliveryFormatService();

      // Update Delivery Format
      if (deliveryFormat > 0) result = await deliveryFormatService.updateDeliveryFormat(deliveryFormat, data);
      // Add new Delivery Format
      else result = await deliveryFormatService.createDeliveryFormat(data);

      if (result.success) {
        dispatch(
          showToast({
            message: result.message,
            type: "success",
          })
        );

        setOpen(false);
      }
    }

    loaddata({});
    setLoading(false);
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const clearFormData = () => {
    setText("");
    setCategory("");
    setActive(0);
    setErrors({
      text: false,
    });
  };

  useEffect(() => {
    if (deliveryFormat) {
      setLoading(true);
      const deliveryFormatService = new DeliveryFormatService();

      deliveryFormatService
        .getDeliveryFormat(deliveryFormat)
        .then((response) => {
          if (response.success) {
            const { text, status, Category, type } = response.data;
            setText(text);
            setCategory(Category);
            setType(type);
            setActive(status == 1);
          }
          setLoading(false);
        })
        .catch((e) => {
          setLoading(false);
        });
    }

    return () => clearFormData();
  }, []);

  return (
    <Dialog className={classes.dialogPaper} open={true}>
      <AppBar sx={{ position: "relative" }}>
        <Toolbar className={classes.Toolbar}>{deliveryFormat > 0 ? "Edit" : "Add"} Delivery Format</Toolbar>
        <IconButton
          aria-label="close"
          onClick={() => handleCancel()}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "black",
          }}
        >
          <CloseIcon />
        </IconButton>
      </AppBar>
      <Box sx={{ width: "100%" }} className={classes.container}>
        <Backdrop sx={{ color: "red", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
          <CircularProgress color="primary" />
        </Backdrop>
        <Box sx={{ width: "100%" }} component="form" className={classes.formContainer}>
          <Grid container spacing={2} style={{ marginTop: "10px" }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              {deliveryFormat == 0 ? (
                <TextField
                  margin="normal"
                  label="Category"
                  variant="outlined"
                  value={category}
                  onChange={(e) => setCategory(e.target.value)}
                  select
                  sx={{ mr: "20px", mt: 0, width: "200px" }}
                  className={classes.StatusDrp}
                >
                  {categories.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>
              ) : (
                <>Category: {category}</>
              )}
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12}>
              <TextField
                autoFocus
                margin="dense"
                fullWidth
                label="Text"
                type="text"
                variant="outlined"
                value={text}
                onChange={(e) => setText(e.target.value)}
                error={errors.text}
                helperText={errors.text ? "Text length should be between 2 and 50!" : ""}
                required
              />
            </Grid>

            <Grid item xs={12} sm={6} md={6} lg={6}>
              <TextField
                autoFocus
                margin="dense"
                fullWidth
                label="Type"
                type="text"
                variant="outlined"
                value={type}
                select
                onChange={(e) => setType(e.target.value)}
                required
              >
                {deliveryFormatTypes.map((type) => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item sm={6} xs={6} lg={6} md={6}>
              <FormGroup className={classes.formLabel}>
                <FormLabel>Status:</FormLabel>
                <FormLabel className="Status">Inactive</FormLabel>
                <Switch
                  checked={active !== undefined && active ? true : false}
                  color={active !== undefined ? "success" : ""}
                  onChange={(e) => setActive(+!active)}
                />
                <FormLabel className="Status">Active</FormLabel>
              </FormGroup>
            </Grid>
          </Grid>
        </Box>
        <Box>
          <DialogActions>
            <ButtonUI variant="contained" color="secondary" onClick={handleCancel}>
              Cancel
            </ButtonUI>
            <ButtonUI
              onClick={handleSave}
              variant="contained"
              color="success"
              style={{ marginLeft: 15 }}
              disabled={!text.trim() || !category || !type || loading}
            >
              Save
            </ButtonUI>
          </DialogActions>
        </Box>
      </Box>
    </Dialog>
  );
}
